import type { ComponentType, SVGProps } from 'react';

import { IconDashboard, IconInteractions, IconLock, IconSettings } from '../ui/icons.js';

/** The sidebar's routes (S03). */
export interface NavItem {
  to: string;
  label: string;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
}

export const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Dashboard', Icon: IconDashboard },
  { to: '/interactions', label: 'Interactions', Icon: IconInteractions },
  { to: '/agents', label: 'Agent Configuration', Icon: IconSettings },
  // Access has no counterpart in the mock — it is S02's addition — so it borrows
  // the mock's own lock rather than introducing a shape from a different set.
  { to: '/access', label: 'Access', Icon: IconLock },
];

/** Per-route title and subtitle for the top bar. */
export const ROUTE_TITLES: Record<string, [string, string]> = {
  '/': ['Dashboard', 'Inbound call activity overview'],
  '/interactions': ['Interactions', 'Analysed calls and what callers needed'],
  '/agents': ['Agent Configuration', "Edit your agents' details & instructions"],
  '/access': ['Access', 'Who may sign in to this console'],
};
